module.exports = __webpack_public_path__ + "resource/img/logout.598ce2f9.svg";